import { instance } from "libs/api";

import { ApiRoutesSupportTickets } from "../../constants/enums";

export interface GetActiveTicketsCountResponse {
  count: number;
}

export interface GetActiveTicketsCountParams {
  createdByAi?: boolean;
}

export const requestGetActiveTicketsCount = async (
  params: GetActiveTicketsCountParams = {},
): Promise<GetActiveTicketsCountResponse> => {
  return await instance.get(`${ApiRoutesSupportTickets.Tickets}/active-count`, {
    params,
  });
};
